<div class="parent">
  <p>
    You have enabled two factor authentication. Please enter the code from your
    authenticator app below:
  </p>
  <input #codeInput placeholder="Enter 6 digit code" />
  <div class="enableTwoFactorAuthenticationButtonParent">
    <button (click)="submitTwoFactorAuthenticationCode(codeInput.value)">
      Submit
    </button>
  </div>
  <div *ngIf="message">{{ message }}</div>
</div>
